import { dialogActions } from '../../services';

let index = 0;

export const dialogReducer = ( state = {show:false, component:null, item:null}, action ) => {
  switch ( action.type ) {
    case dialogActions.SHOWDIALOG:
      return {...state, ["show"]:true,["component"]:action.component, ["item"]:action.item};
    case dialogActions.CLOSEDIALOG:
        return {...state, ["show"]:false,["component"]:null};
    default:
      return state;
  }
};